function SvgComponent(props) {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Property 1=Variant4">
        <g clip-path="url(#clip0_2600_1325)">
          <g id="Group 1">
            <path
              id="Vector"
              d="M91.0952 117.288H68.9271V139.46H91.0952V117.288Z"
              fill="#121014"
            />
            <path
              id="Vector_2"
              d="M103.586 130.231H56.4367C49.6129 130.231 44.0811 135.764 44.0811 142.589V181.712C44.0811 188.537 49.6129 194.07 56.4367 194.07H103.586C110.41 194.07 115.942 188.537 115.942 181.712V142.589C115.942 135.764 110.41 130.231 103.586 130.231Z"
              fill="#EE6C4C"
            />
            <path
              id="Vector_3"
              d="M81.7104 31.8916H78.3345V61.3796H81.7104V31.8916Z"
              fill="#D65238"
            />
            <path
              id="Vector_4"
              d="M31.2753 76.3936H22.7007C21.2091 76.3936 20 77.6029 20 79.0947V99.3087C20 100.8 21.2091 102.01 22.7007 102.01H31.2753C32.7669 102.01 33.976 100.8 33.976 99.3087V79.0947C33.976 77.6029 32.7669 76.3936 31.2753 76.3936Z"
              fill="#D65238"
            />
            <path
              id="Vector_5"
              d="M137.299 76.3936H128.725C127.233 76.3936 126.024 77.6029 126.024 79.0947V99.3087C126.024 100.8 127.233 102.01 128.725 102.01H137.299C138.791 102.01 140 100.8 140 99.3087V79.0947C140 77.6029 138.791 76.3936 137.299 76.3936Z"
              fill="#D65238"
            />
            <path
              id="Vector_6"
              d="M113.938 57.3506H46.084C34.8974 57.3506 25.8289 66.4208 25.8289 77.6095V100.795C25.8289 111.983 34.8974 121.054 46.084 121.054H113.938C125.125 121.054 134.194 111.983 134.194 100.795V77.6095C134.194 66.4208 125.125 57.3506 113.938 57.3506Z"
              fill="#EE6C4C"
            />
            <path
              id="Vector_7"
              d="M96.6991 65.4087H63.3232C50.1852 65.4087 39.5347 76.0612 39.5347 89.2017C39.5347 102.342 50.1852 112.995 63.3232 112.995H96.6991C109.837 112.995 120.488 102.342 120.488 89.2017C120.488 76.0612 109.837 65.4087 96.6991 65.4087Z"
              fill="#121014"
            />
            <path
              id="EL"
              d="M103.702 86C104.151 86 104.544 85.6212 104.544 85.126C104.544 84.6307 104.179 84.2519 103.702 84.2519L91.5214 84.1645L102.495 78.6581C102.916 78.4541 103.085 77.9297 102.888 77.4927C102.692 77.0557 102.186 76.8808 101.765 77.0848L90.4549 82.7661C89.7813 83.1157 89.4164 83.844 89.5848 84.6307C89.7532 85.3882 90.3707 85.9126 91.1285 85.9126L103.702 86Z"
              fill="#FEFEFC"
            />
            <path
              id="Vector_8"
              d="M80.0227 96.7653C75.8366 96.7653 72.4158 93.3663 72.4158 89.157C72.5038 88.4817 72.7083 88.4817 73.0909 88.4817C73.4735 88.4817 73.7661 88.7743 73.7661 89.157C73.7661 92.601 76.5793 95.4148 80.0227 95.4148C83.466 95.4148 86.2792 92.601 86.2792 89.157C86.4286 88.4817 86.5718 88.4817 86.9544 88.4817C87.337 88.4817 87.6296 88.7743 87.6296 89.157C87.6296 93.3438 84.2312 96.7653 80.0227 96.7653Z"
              fill="#FEFEFC"
            />
            <path
              id="Vector_9"
              d="M80.0001 41.0079C84.9719 41.0079 89.0023 36.9767 89.0023 32.004C89.0023 27.0312 84.9719 23 80.0001 23C75.0283 23 70.9978 27.0312 70.9978 32.004C70.9978 36.9767 75.0283 41.0079 80.0001 41.0079Z"
              fill="#EE6C4C"
            />
            <path
              id="EL_2"
              d="M56.386 86.1975C55.9369 86.1975 55.544 85.8188 55.544 85.3235C55.544 84.8282 55.9089 84.4494 56.386 84.4494L68.5666 84.362L57.5928 78.8556C57.1718 78.6516 57.0034 78.1272 57.1999 77.6902C57.3964 77.2532 57.9016 77.0784 58.3225 77.2823L69.6332 82.9636C70.3067 83.3132 70.6716 84.0415 70.5032 84.8282C70.3348 85.5857 69.7173 86.1101 68.9596 86.1101L56.386 86.1975Z"
              fill="#FEFEFC"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2600_1325">
          <rect width="160" height="160" rx="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
